<template>
  <v-app-bar density="comfortable" elevation="1">
    <v-icon color="amber-darken-2" class="ml-3 mr-1">mdi-barley</v-icon>
    <v-app-bar-title class="text-subtitle-1 font-weight-bold text-grey-darken-3">
      一粒麦子课时
    </v-app-bar-title>
    <v-spacer></v-spacer>

    <v-menu>
      <template v-slot:activator="{ props }">
        <v-btn icon color="primary" v-bind="props" variant="text" size="small" class="mr-1">
          <v-icon color="teal">mdi-account-circle</v-icon>
        </v-btn>
      </template>

      <v-list density="compact" elevation="2">
        <v-list-item v-for="(item, i) in items" :key="i" @click="logout" :title="item.title">
          <template v-slot:prepend>
            <v-icon size="small" color="error">mdi-logout</v-icon>
          </template>
        </v-list-item>
      </v-list>
    </v-menu>

    <span class="text-body-2 mr-3 font-weight-medium text-grey-darken-2">{{ userName }}</span>
  </v-app-bar>
</template>

<script>
import { Logout } from "@/api";

export default {
  name: "Headbar",
  data() {
    return {
      userName: localStorage.getItem("user") || "",
      items: [{ title: "退出登录" }],
    };
  },
  methods: {
    logout() {
      Logout().then(() => {
        localStorage.clear();
        sessionStorage.clear();

        this.$router.push({
          name: "login",
        });
      });
    },
  },
};
</script>
